import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileDownloadHandler, SessionService } from '@edl-development/edl-common';
import { ToastrService } from 'ngx-toastr';
import { FileAttachment } from 'src/app/model/attachment/file-attachment.model';
import { FileService } from 'src/app/services/file.service';

@Component({
    selector: 'paetep-attachment-button',
    templateUrl: './attachment-button.component.html',
    styleUrls: ['./attachment-button.component.scss']
})
export class AttachmentButtonComponent {
    @Input() attachment?: FileAttachment;
    @Input() canDeleteAttachment: boolean = false;
    @Input() shouldDisplayDate: boolean = true;

    @Output() onAttachmentDeleted = new EventEmitter<FileAttachment>();

    constructor(
        private fileService: FileService,
        private fileHandler: FileDownloadHandler,
        private toastr: ToastrService,
        private sessionService: SessionService
    ) { }

    isMyAttachment(){
        return this.sessionService.user?.UserID === this.attachment?.userID;
    }

    viewAttachement() {
        this.fileService
            .getFileResponse(this.attachment!.fileID)
            .subscribe((fileResponse: Blob) => {
                this.fileHandler.saveFile(fileResponse, this.attachment!.fileName);
            });
    }

    deleteAttachement(){
        if (window.confirm("Are you certain you want to delete this attachment?")) {
            this.fileService
                .deleteFile(this.attachment!)
                .subscribe(() => {
                    this.toastr.success("Attachment removed.");
                    this.onAttachmentDeleted.emit(this.attachment);
                });
        }
    }
}
